export default "__VITE_ASSET__CWbMt5w$__"